import { Backdrop, Box, CircularProgress } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

export default function Loading() {
   const isLoading = useSelector((store) => store.quotaModification.isLoading);
   return (
      <Box>
         <Backdrop
            sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
         }}
         open={isLoading}
         >
            <CircularProgress />
         </Backdrop>
      </Box>
   );
}
